export interface ProjectContact {
    contactId: number;
    contactType: string;
    contactSubType: string;

    /*Personal Info*/
    id: number;
    first_name: string;
    last_name: string | null;
    email: string;
    mobile: string | null;
    landline: string | null;
    address: string | null;
    city: string | null;
    post_code: string | null;
    profile_image: string;
    role_name: string | null;

    icChecked: boolean;
}

export const mapProjectContact = (data: any): ProjectContact => {
    if (!data) {
        throw new Error('Invalied Project Contact type')
    }

    const ProjectContact: ProjectContact = {
        contactId: data.contactId,
        contactType: data.contactType,
        contactSubType: data.contactSubType,

        id: data.id,
        first_name: data.first_name,
        last_name: data.last_name,
        email: data.email,
        mobile: data.mobile,
        landline: data.landline,
        address: data.address,
        city: data.city,
        post_code: data.post_code,
        profile_image: data.profile_image,
        role_name: data?.role_name || '',
        icChecked: false,

    }

    return ProjectContact;

}

export const mapProjectContacts = (data: any[]): ProjectContact[] => {
    if (!Array.isArray(data)) {
        throw new Error('Invalid ProjectContact data');
    }


    return data.map(mapProjectContact);
};